<script>
export default {
  mounted() {
    setTimeout(() => {
      window.location.href = 'https://itunes.apple.com/app/id1481179776'
    }, 1000)
  }
}
</script>



// WEBPACK FOOTER //
// src/views/sharedownload/index.vue